export default __webpack_public_path__ + "static/media/docs-burnout-info_lt.e4eb00cd.png";